import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components/macro'
import variables from 'core/styles/variables'

const DEFAULT_LABEL_WIDTH = '200px'

const RowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const RowLeft = styled.div`
  box-sizing: border-box;
  flex-shrink: 0;
  width: ${props => props.leftWidth};
  padding-right: 16px;
  text-align: right;
  color: ${variables.colorBlack60};
  font-style: normal;
  font-weight: normal;
  padding-top: ${props => (props.isFirst ? '0' : '16px')};
  padding-bottom: 16px;
`

// padding-top for both left and content are set to zero for the first item
// so that it's content will align with the list's overall left

const RowContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: ${props => (props.isFirst ? '0' : '16px')};
  padding-bottom: 16px;
  border-top: ${props => {
    return props.isFirst ? 'none' : `1px solid ${variables.colorBlack20}`
  }};
`

const CardSectionListRow = ({ children, left, leftWidth, isFirst }) => {
  return (
    <RowContainer isFirst={isFirst}>
      <RowLeft isFirst={isFirst} leftWidth={leftWidth}>
        {left}
      </RowLeft>
      <RowContent isFirst={isFirst}>{children}</RowContent>
    </RowContainer>
  )
}

CardSectionListRow.propTypes = {
  children: PropTypes.node,
  left: PropTypes.node,
  leftWidth: PropTypes.string,
  isFirst: PropTypes.bool
}

CardSectionListRow.defaultProps = {
  leftWidth: DEFAULT_LABEL_WIDTH
}

export default CardSectionListRow
